var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLikeWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "27px",
    viewBox: "0 0 35 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLikeWhite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "On-the-ground-Copy-2",
    transform: "translate(-245.000000, -610.000000)",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(30.000000, 606.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.881102,7.9037037 C233.707046,7.03518519 234.691278,6.30833333 235.783065,5.80092593 C236.875867,5.29074074 238.077239,5 239.337462,5 C240.597685,5 241.799057,5.23333333 242.891859,5.65462963 C243.984661,6.07685185 244.967878,6.68703704 245.793821,7.44074074 C246.61875,8.19444444 247.289448,9.09259259 247.751124,10.0898148 C248.214829,11.0861111 248.469512,12.1833333 248.469512,13.3333333 C248.469512,14.4833333 248.213815,15.5805556 247.751124,16.5768519 C247.289448,17.5740741 246.620779,18.4722222 245.793821,19.2259259 C244.968893,19.9796296 233.327558,29.5777778 232.234756,30 C231.141954,29.5777778 219.500619,19.9796296 218.674676,19.2259259 C217.848733,18.4722222 217.180064,17.5740741 216.717373,16.5768519 C216.255697,15.5805556 216,14.4833333 216,13.3333333 C216,12.1833333 216.255697,11.0861111 216.717373,10.0898148 C217.180064,9.09259259 217.847718,8.19444444 218.674676,7.44074074 C219.500619,6.68703704 220.484851,6.07685185 221.577653,5.65462963 C222.669441,5.23333333 223.870813,5 225.13205,5 C226.393288,5 227.59466,5.29074074 228.686447,5.79907407 C229.779249,6.30833333 230.619379,6.81235653 231.446337,7.68087505 C232.27228,8.55031949 232.054144,8.77314815 232.881102,7.9037037 Z",
    id: "icLikeWhite"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLikeWhite);
export default __webpack_public_path__ + "static/media/icLikeWhite.7a35ce60658badf12d8be909cb10769d.svg";
export { ForwardRef as ReactComponent };